import { ApiHeader } from './headers';
import { ApiRequest } from './request';
import { ApiConfig } from '../../../application/configurations/IConfig';
import { UtilityService } from '../utils';
import { AuthService } from '../authentication/auth';
import { setPreviewToken } from '../../../presentation/containers/results/searchReducer';
import { store } from '../../../application/store';

/**
 * api request layer handle all api calls in this application
 */
export default class ApiService {
  /**
   * if token error thrown, this function will be called and reload the page after clearing the site data
   */
  static tokenErrorHandler = () => {
    UtilityService.clearSiteData();
    window.location.reload();
  };

  /**
   * method for handling the api response
   * if it receive token expiry error as response, it will automatically renew
   * the token and retry same request call 3 times
   * @param   {array} apiData  configuration for creating the request
   * @return  {array} return response data
   */
  static handleResponse = async (
    apiData: ApiConfig,
    res?: any
  ): Promise<Response> => {
    let responseData: any = res ? res.json() : [];
    if (res && !res.ok && apiData) {
      /**
       * if token invalid response, this will retry same request 3 times after token refresh
       */
      if (res.status === 419) {
        this.tokenErrorHandler();
      } else {
        throw new Error(responseData);
      }
    }

    return responseData;
  };

  /**
   * method for creating api request from given config and handle http calls
   * if it receive token expiry error as response, it will automatically renew
   * the token and retry same request call 3 times
   * @param   {array} config  configuration for creating the request
   * @return  {object} return a promise object which resolve/reject based on the api request response
   */
  static requestApi = async (config: [ApiConfig]) => {
    let httpRequest: Promise<Response>[] = [];

    let requestHeader = new ApiHeader();

    /**
     * accessing bearer token from localstorage and
     * setting it with request headers
     */
    // const bearerToken = accessConfig ? accessConfig.idToken : '';
    // const accessToken = accessConfig ? accessConfig.accessToken : '';
    // const userAccessToken =
    //   accessConfig && accessConfig.user ? accessConfig.user.accessToken : '';

    /**
     * iterate through the config array passed
     */
    await new Promise<void>((resolve, reject) => {
      if (config.length > 0) {
        config.forEach(async (apiData, configKey) => {
          /**
           * accessing the new token silently
           */
          let authData: any = {};
          authData=await ApiService.getAccessToken(apiData.accountInfo, apiData.scopes);

         if (apiData.headers && Object.keys(apiData.headers).length > 0) {
            requestHeader.setAdditionalHeaders(apiData.headers, authData);
          }
          /**
           * creating individual request and add it to an array for handling all the request parallel
           */
          httpRequest.push(
            window
              .fetch(
                new ApiRequest(apiData, requestHeader.headersObject).requestBody
              )
              .then((res) => this.handleResponse(apiData, res))
          );

          if (configKey === config.length - 1) {
            resolve();
          }
        });
      } else {
        resolve();
      }
    });

    return Promise.all(httpRequest);
  };
    /**
     * accessing the new token silently
     */

  static getAccessToken = async(accInfo : any,apiScope : any) => {
     
     let authData: any = {};
    
    await AuthService(accInfo, apiScope)
       .then((response: any) => {
         authData = response;
         // save the token in redux for SmartPreview.
         store.dispatch(setPreviewToken(authData.accessToken));
       })
       .catch(() => {
         this.tokenErrorHandler();
       });

       return authData;
  }
}
